<template>

  <Modal

    v-model="dialogVisible"

    class-name="appeal-dialog"

    :title="dialogTitle"

    width="980"

    :mask-closable="false"

    @on-cancel="handleDismiss"

  >

    <div class="appeal-dialog-body">

      <p class="appeal-dialog-tip">

        对 {{ appealVersionText }} 的审核驳回结果发起申诉。请填写申诉理由，提交后需等待 TT 反馈；申诉中不可修改送审资料。

      </p>



      <div class="appeal-form-field">

        <div class="appeal-form-label">

          申诉理由<span class="appeal-required">*</span>

        </div>

        <Input

          v-model="appealReason"

          type="textarea"

          :rows="5"

          :maxlength="MAX_REASON_LENGTH"

          placeholder="请说明申诉依据"

          class="appeal-reason-input"

        />

        <div class="appeal-form-hint">必填，最多 {{ MAX_REASON_LENGTH }} 字</div>

      </div>



      <div class="appeal-form-field appeal-form-field--upload">

        <div class="appeal-form-label">上传附件（选填）</div>

        <div class="appeal-upload-row">

          <Button

            class="appeal-upload-btn"

            :disabled="attachments.length >= MAX_ATTACHMENTS || attachmentUploading"

            @click="handleSelectFiles"

          >

            选择文件

          </Button>

          <span class="appeal-upload-placeholder">{{ uploadPlaceholderText }}</span>

        </div>

        <div class="appeal-form-hint">

          最多 {{ MAX_ATTACHMENTS }} 个，每个不超过 200 MB。

        </div>

        <div class="appeal-form-hint appeal-form-hint--count">

          已选 {{ attachments.length }} / {{ MAX_ATTACHMENTS }} 个附件

        </div>

        <ul v-if="attachments.length" class="appeal-attachment-list">

          <li

            v-for="(file, index) in attachments"

            :key="`${file.name}-${index}`"

            class="appeal-attachment-item"

          >

            <span class="appeal-attachment-name">{{ file.name }}</span>

            <span class="appeal-attachment-size">

              <template v-if="file.uploading">上传中…</template>

              <template v-else-if="file.uploadError">{{ file.uploadError }}</template>

              <template v-else>{{ formatFileSize(file.size) }}</template>

            </span>

            <span class="appeal-attachment-remove" @click="removeAttachment(index)">移除</span>

          </li>

        </ul>

      </div>



      <input

        ref="fileInput"

        type="file"

        class="appeal-file-input"

        multiple

        @change="handleFileChange"

      />

    </div>



    <template #footer>

      <Button @click="handleCancelBack">取消</Button>

      <Button

        type="primary"

        :loading="submitting"

        :disabled="!canConfirmSubmit"

        @click="handleSubmit"

      >

        确认发起申诉

      </Button>

    </template>

  </Modal>

</template>



<script>

import { postTtMediaReviewAppeal } from '@/api/short-review'

import { uploadReviewMaterialFile } from '../../utils/reviewFileUpload'

import { resolveAppealTtVersion } from '../../utils/appeal'



const MAX_REASON_LENGTH = 500

const MAX_ATTACHMENTS = 10

const MAX_FILE_SIZE_BYTES = 200 * 1024 * 1024



function formatAppealVersion(row) {

  if (!row) return '—'

  const rejectVersion = row.rejectVersion

  if (rejectVersion != null && rejectVersion !== '') {

    const text = String(rejectVersion).trim()

    return /^V/i.test(text) ? text.toUpperCase() : `V${text}`

  }

  const ttVersion = row.reviewTtVersion

  if (ttVersion != null && Number(ttVersion) > 0) {

    return `V${ttVersion}`

  }

  return '—'

}



export default {

  name: 'AppealDialog',

  props: {

    visible: {

      type: Boolean,

      default: false

    },

    row: {

      type: Object,

      default: () => ({})

    }

  },

  data() {

    return {

      MAX_REASON_LENGTH,

      MAX_ATTACHMENTS,

      dialogVisible: false,

      appealReason: '',

      attachments: [],

      submitting: false

    }

  },

  computed: {

    dialogTitle() {
      const name = (this.row && this.row.playName) || '—'
      return `发起申诉 · ${name}`
    },

    appealVersionText() {

      return formatAppealVersion(this.row)

    },

    uploadPlaceholderText() {

      if (!this.attachments.length) return '未选择任何文件'

      if (this.attachments.length === 1) return this.attachments[0].name

      return `已选择 ${this.attachments.length} 个文件`

    },

    attachmentUploading() {

      return this.attachments.some((item) => item.uploading)

    },

    canConfirmSubmit() {

      if (this.submitting || this.attachmentUploading) return false

      if (!(this.appealReason || '').trim()) return false

      return !this.attachments.some(

        (item) => item.uploading || (item.uploadError && !item.fileId)

      )

    }

  },

  watch: {

    visible(val) {

      this.dialogVisible = val

      if (val) {

        this.resetForm()

      }

    },

    dialogVisible(val) {

      this.$emit('update:visible', val)

    }

  },

  methods: {

    resetForm() {

      this.appealReason = ''

      this.attachments = []

      this.submitting = false

      const input = this.$refs.fileInput

      if (input) input.value = ''

    },

    /** 右上角 ×：仅关闭申诉弹窗，不回到驳回/审核记录 */
    handleDismiss() {
      if (this.submitting) return
      this.dialogVisible = false
      this.$emit('dismiss')
    },
    /** 底部「取消」：关闭并回到打开申诉前的弹窗 */
    handleCancelBack() {
      if (this.submitting) return
      this.dialogVisible = false
      this.$emit('close')
    },

    handleSelectFiles() {

      const input = this.$refs.fileInput

      if (!input) return

      input.value = ''

      input.click()

    },

    formatFileSize(size) {

      if (size == null || Number.isNaN(size)) return '—'

      if (size < 1024) return `${size} B`

      if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`

      return `${(size / (1024 * 1024)).toFixed(1)} MB`

    },

    uploadAttachmentItem(item, file) {

      this.$set(item, 'uploading', true)

      this.$set(item, 'uploadError', '')

      return uploadReviewMaterialFile(file)

        .then(({ fileId }) => {

          this.$set(item, 'fileId', Number(fileId))

          this.$set(item, 'uploading', false)

        })

        .catch((err) => {

          this.$set(item, 'uploading', false)

          this.$set(

            item,

            'uploadError',

            (err && err.message) || '上传失败'

          )

          this.$Message.error(`「${item.name}」上传失败`)

        })

    },

    handleFileChange(event) {

      const files = event.target.files

      if (!files || !files.length) return

      for (let i = 0; i < files.length; i += 1) {

        if (this.attachments.length >= MAX_ATTACHMENTS) {

          this.$Message.warning(`最多选择 ${MAX_ATTACHMENTS} 个附件`)

          break

        }

        const file = files[i]

        if (file.size > MAX_FILE_SIZE_BYTES) {

          this.$Message.warning(`「${file.name}」超过 200 MB，请重新选择`)

          continue

        }

        const item = {

          name: file.name,

          size: file.size,

          fileId: null,

          uploading: true,

          uploadError: ''

        }

        this.attachments.push(item)

        this.uploadAttachmentItem(item, file)

      }

    },

    removeAttachment(index) {

      if (this.submitting) return

      this.attachments.splice(index, 1)

    },

    buildAppealPayload(reason) {

      const attachmentIds = this.attachments

        .map((item) => Number(item.fileId))

        .filter((id) => !Number.isNaN(id) && id > 0)

      const body = {

        reason,

        attachmentIds

      }

      const ttVersion = resolveAppealTtVersion(this.row)

      if (ttVersion) {

        body.ttVersion = ttVersion

      }

      return body

    },

    async handleSubmit() {

      const reason = (this.appealReason || '').trim()

      if (!reason) {

        this.$Message.warning('请填写申诉理由')

        return

      }

      if (reason.length > MAX_REASON_LENGTH) {

        this.$Message.warning(`申诉理由最多 ${MAX_REASON_LENGTH} 字`)

        return

      }

      if (this.attachmentUploading) {

        this.$Message.warning('附件上传中，请稍候再提交')

        return

      }

      const failed = this.attachments.filter(

        (item) => item.uploadError && !item.fileId

      )

      if (failed.length) {

        this.$Message.warning('部分附件上传失败，请移除后重试或重新选择')

        return

      }



      const id = this.row && this.row.id

      if (id == null || id === '') {

        this.$Message.error('缺少审核记录，无法发起申诉')

        return

      }

      const ttVersion = resolveAppealTtVersion(this.row)

      if (!ttVersion) {

        this.$Message.error('缺少送审版本号 ttVersion，无法发起申诉')

        return

      }



      this.submitting = true

      try {

        const payload = this.buildAppealPayload(reason)

        const axiosRes = await postTtMediaReviewAppeal(id, payload)

        const res = (axiosRes && axiosRes.data) || axiosRes || {}

        if (res.code === 200) {

          const taskId =

            res.data && res.data.taskId ? String(res.data.taskId) : ''

          this.$emit('success', {

            ...this.row,

            appealReason: reason,

            attachmentIds: payload.attachmentIds,

            task: res.data,

            taskId

          })

          this.dialogVisible = false

          return

        }

        this.$Message.error({

          content: res.message || '发起申诉失败',

          duration: 6

        })

      } catch (err) {

        const msg =

          (err && err.message) ||

          (err && err.data && err.data.message) ||

          '发起申诉失败'

        this.$Message.error({

          content: msg,

          duration: 6

        })

      } finally {

        this.submitting = false

      }

    }

  }

}

</script>



<style scoped>

.appeal-dialog-body {

  box-sizing: border-box;

  height: 100%;

  overflow-y: auto;

}



.appeal-dialog-tip {

  margin: 0 0 20px;

  font-size: 13px;

  line-height: 22px;

  color: #909399;

}



.appeal-form-field {

  margin-bottom: 22px;

}



.appeal-form-field--upload {

  margin-bottom: 0;

}



.appeal-form-label {

  margin-bottom: 8px;

  font-size: 14px;

  line-height: 22px;

  color: #303133;

}



.appeal-required {

  margin-left: 2px;

  color: #f56c6c;

}



.appeal-form-hint {

  margin-top: 8px;

  font-size: 12px;

  line-height: 20px;

  color: #909399;

}



.appeal-form-hint--count {

  margin-top: 4px;

}



.appeal-reason-input >>> textarea {

  font-size: 13px;

  line-height: 22px;

  resize: vertical;

}



.appeal-upload-row {

  display: flex;

  align-items: center;

  box-sizing: border-box;

  min-height: 38px;

  padding: 4px 12px 4px 4px;

  border: 1px solid #dcdfe6;

  border-radius: 4px;

  background: #fff;

}



.appeal-upload-btn {

  flex-shrink: 0;

  height: 30px;

  padding: 0 12px;

  font-size: 13px;

  font-weight: 600;

}



.appeal-upload-placeholder {

  margin-left: 12px;

  font-size: 13px;

  line-height: 22px;

  color: #303133;

  overflow: hidden;

  text-overflow: ellipsis;

  white-space: nowrap;

}



.appeal-file-input {

  display: none;

}



.appeal-attachment-list {

  margin: 10px 0 0;

  padding: 0;

  list-style: none;

}



.appeal-attachment-item {

  display: flex;

  align-items: center;

  gap: 12px;

  padding: 6px 0;

  font-size: 13px;

  line-height: 20px;

  border-bottom: 1px solid #f0f0f0;

}



.appeal-attachment-name {

  flex: 1;

  min-width: 0;

  color: #303133;

  overflow: hidden;

  text-overflow: ellipsis;

  white-space: nowrap;

}



.appeal-attachment-size {

  flex-shrink: 0;

  color: #909399;

}



.appeal-attachment-remove {

  flex-shrink: 0;

  color: #2d8cf0;

  cursor: pointer;

}



.appeal-attachment-remove:hover {

  color: #57a3f3;

}

</style>



<style>

.appeal-dialog {

  display: flex;

  align-items: center;

  justify-content: center;

}



.appeal-dialog .ivu-modal {

  top: 0;

}



.appeal-dialog .ivu-modal-content {

  display: flex;

  flex-direction: column;

  height: 574px;

  box-sizing: border-box;

}



.appeal-dialog .ivu-modal-header {

  flex-shrink: 0;

  height: 76px;

  box-sizing: border-box;

  padding: 0 24px;

  border-bottom: 1px solid #e8eaec;

  display: flex;

  align-items: center;

}



.appeal-dialog .ivu-modal-header-inner {

  box-sizing: border-box;

  flex: 1;

  min-width: 0;

  max-width: 100%;

  padding-right: 48px;

  overflow: hidden;

  text-overflow: ellipsis;

  white-space: nowrap;

  font-size: 18px;

  font-weight: 600;

  line-height: 24px;

  color: #263f58;

}



.appeal-dialog .ivu-modal-close {

  top: 22px;

  right: 20px;

  z-index: 1;

}



.appeal-dialog .ivu-modal-body {

  flex-shrink: 0;

  height: 432px;

  box-sizing: border-box;

  padding: 24px;

  overflow: hidden;

}



.appeal-dialog .ivu-modal-footer {

  flex-shrink: 0;

  height: 66px;

  box-sizing: border-box;

  padding: 0 24px;

  border-top: 1px solid #e8eaec;

  display: flex;

  align-items: center;

  justify-content: flex-end;

}



.appeal-dialog .ivu-modal-footer .ivu-btn {

  height: 35px;

  padding: 8px 15px;

  font-size: 13px;

  line-height: 17px;

}



.appeal-dialog .ivu-modal-footer .ivu-btn + .ivu-btn {

  margin-left: 8px;

}

</style>


